import React from 'react';
import { segmentsTracking } from 'src/common/lib/tracker';
import PublicImage from 'src/common/components/PublicImage';
import { ArrowRight20 } from '@carbon/icons-react';
import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';
import {
  checkForEComm,
  WindowOpenFunction,
} from 'src/common/hooks/widgets/useLang';
import { Button } from 'carbon-components-react';

type ResponseStepProps = {
  pathSelected: string;
  picture: string;
  title: string;
  linkUrl?: string;
  iconPath: string;
  linkText: string;
  learnMore: string;
  emailSales: string;
  handleUrxForm: () => void;
  setEmailBtnState: React.Dispatch<React.SetStateAction<boolean>>;
  windowOpen?: WindowOpenFunction;
  urx?: boolean;
  bgColor: string;
  title2?: string;
  useTranslation?: TranslationFunction;
  ecomm: string | undefined;
};

const ResponseStep = ({
  pathSelected,
  picture,
  learnMore,
  emailSales,
  title,
  linkUrl,
  linkText,
  iconPath,
  handleUrxForm,
  urx,
  bgColor,
  title2,
  windowOpen,
  ecomm,
}: ResponseStepProps) => {
  const handleEmail = () => {
    handleUrxForm();
  };

  return (
    <div className="bx--grid bx--grid--condensed">
      <div className="bx--row">
        <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
          <div className="bx--row">
            <div className="bx--col-lg-9 bx--col-md-5 bx--col-sm-4 disp-flex">
              <div className="padding_q8" style={{ backgroundColor: bgColor }}>
                <div className="mar-pad">
                  <PublicImage
                    style={{ backgroundColor: bgColor }}
                    imgPath={iconPath}
                    widgetId="spss-purchase-advisor-self-assessment"
                    id="img2"
                    alt="SPSS Self Assessment Steps picture"
                  />
                  <div className="page_body">
                    {title2 != null ? title2 : title}
                  </div>
                  <div className="page_body_2 spss-mar2 spss-mar3">
                    {title2 == null ? linkText : null}
                  </div>
                  {urx || checkForEComm(ecomm, 'NA') ? (
                    <>
                      <Button
                        renderIcon={ArrowRight20}
                        kind="primary"
                        className="cta-button-response"
                        onClick={() => {
                          handleEmail();
                        }}
                      >
                        {title2 != null ? linkText : emailSales}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        renderIcon={ArrowRight20}
                        kind="primary"
                        className="cta-button-response"
                        onClick={() => {
                          segmentsTracking('CTA Clicked', {
                            pageTitle:
                              'SPSS Purchasing Advisor Self Assessment',
                            object:
                              'SPSS Purchasing Advisor Self Assessment page',
                            resultValue: 'CTA clicked',
                            CTA: `${linkText} - ${pathSelected}`,
                            location: `${pathSelected} Assessment`,
                            action: '',
                            field: '',
                          });
                          setTimeout(async () => {
                            windowOpen
                              ? windowOpen(linkUrl, '_blank')
                              : window.open(linkUrl, '_blank');
                          }, 250);
                        }}
                      >
                        {learnMore}
                      </Button>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="bx--col-lg-7 bx--col-md-3 bx--col-sm-4 disp-flex">
              <PublicImage
                imgPath={picture}
                widgetId="spss-purchase-advisor-self-assessment"
                id="img3"
                alt="SPSS Self Assessment Steps picture"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResponseStep;
